var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 44,
    viewBox: "0 0 34 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33 16.2078V38.1538C33 39.4391 32.4943 40.6718 31.5941 41.5806C30.6939 42.4894 29.473 43 28.2 43H5.8C4.52696 43 3.30606 42.4894 2.40589 41.5806C1.50571 40.6718 1 39.4391 1 38.1538V5.84615C1 4.56087 1.50571 3.32824 2.40589 2.41941C3.30606 1.51058 4.52696 1 5.8 1H17.5C18.3484 1.00013 17.337 1.3404 17.937 1.94601L32.063 16.2078C32.6628 16.8136 32.9999 15.3513 33 16.2078Z",
    fill: "#FFE0E0",
    stroke: "#F7404E",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 1C18 5.62463 18 12.8421 18 12.8421C18 13.6796 18.3327 14.4829 18.9249 15.0751C19.5171 15.6673 20.3204 16 21.1579 16H33",
    fill: "#F7404E",
    stroke: "#F7404E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileVideo);
export default __webpack_public_path__ + "static/media/FileVideo.d85afb4a.svg";
export { ForwardRef as ReactComponent };